import React, { Component, createRef, RefObject } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import Template from '../../components/LabelBuilder/Template'
import TemplateProperties from '../../components/LabelBuilder/TemplateProperties'
import Actions from '../../components/LabelBuilder/Actions'
import Aside from '../../components/LabelBuilder/Aside'
import { Transformer } from 'konva/lib/shapes/Transformer'
import ImagePopup from '../../components/Popup/image_popup'
import QpropLogo from '../../assets/logoIcon.png'
import customLabelApi from "../../apis/customLabel.api";
import {WatermarkHelper} from "../../components/WatermarkHelper";
import printService from "../../services/print.service";

interface Props extends RouteComponentProps {
}

interface State {
    isPopUpOpen: boolean
    selectedImage: string
    selectedLabelId: number | null
}

class LabelBuilder extends Component<Props, State> {
  transformerRef: RefObject<Transformer> = createRef()

  constructor (props: State) {
    super(props)

    this.state = {
      isPopUpOpen: false,
      selectedImage: '',
      selectedLabelId: null,
    }

    this.handleImageClick = this.handleImageClick.bind(this)
    this.handlePopupClose = this.handlePopupClose.bind(this)
  }

  handleImageClick (clickedImage: string,  labelId?: number) {
    this.setState({
      isPopUpOpen: true,
      selectedImage: clickedImage || QpropLogo,
      selectedLabelId: labelId ?? null,
    })
  }

    handlePopupClose () {
        this.setState({ isPopUpOpen: false, selectedImage: '', selectedLabelId: null })
    }

    handlePopupPrint = async () => {
        const { selectedLabelId } = this.state
        if (!selectedLabelId) return

        try {
            customLabelApi.print(selectedLabelId, { amount: 1 }, async (markups) => {
                if (!markups) {
                    return
                }

                markups = await WatermarkHelper.applyWatermarks(markups)
                printService.printMarkups(markups)
            })
        } catch (err) {
            console.error('Print failed:', err)
        }
    }

  render () {
    return (
            <>
                <ContentLayout
                    noGap={true}
                    className="h-[calc(100vh-40px)]">
                    <ContentMain
                        layout="twoThird"
                        className="border-r border-blue-100 flex flex-col">
                        <div className='flex-none'>
                            <TemplateProperties/>
                        </div>
                        <div className='flex-auto overflow-auto bg-gray-200'>
                            <Template transformerRef={this.transformerRef}/>
                        </div>
                        <div className='flex-none'>
                            <Actions transformerRef={this.transformerRef} handleImageClick={this.handleImageClick}/>

                        </div>
                    </ContentMain>
                    <ContentMain
                        layout="oneThird"
                        className='overflow-y-scroll'>
                        <Aside transformerRef={this.transformerRef}/>
                    </ContentMain>
                </ContentLayout>
                <ImagePopup isOpen={this.state.isPopUpOpen} imageLink={this.state.selectedImage}
                            handleCloseClick={this.handlePopupClose}
                            onPrint={this.state.selectedLabelId ? this.handlePopupPrint : undefined}
                />
            </>

    )
  }
}

export default withRouter(LabelBuilder)
